import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function GoThroughSteps({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
   
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h3 className="blue-info-text red-info-heading">
              go to tenant move out page and complete the move out,
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="pink-info-text">
              As you enter the charges for the tenant from the invoice or
              estimate for repairs be sure to only enter wording for items that
              the tenant is responsible for such as if the items is
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="pink-info-text">
              New toilet seat and toilet flange only enter the charge as toilet
              seat and adjust the total accordingly.
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="red-info-heading">
              When selecting how to refund deposit select
            </h3>
          </Col>
          <Col span={24}>
            <p className="pink-info-text">
              -refund all tenants via single check, we will do an electronic
              transfer when able to.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              -under transfer method select to have deposit transferred with
              online transfer
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-heading">
              Select the box to automatically send an email disposition letter
              to the tenant
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default GoThroughSteps;
